// extracted by mini-css-extract-plugin
export default {"EmbebedReportBI":"PowerBiEmbedCustom_EmbebedReportBI__DNcuV"};